import { Components, Theme } from '@mui/material';

export const MuiPopper = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundImage: 'none',
      backgroundColor: theme.palette.neutral.containerHighest,
      color: theme.palette.neutral.onSurface,
      zIndex: theme.zIndex.modal,
    }),
  }
} as Components<Theme>['MuiPopper'];
